import React from 'react';
import Icon from '../../../components/AppIcon';

const AnonymityWarning = () => {
  return (
    <div className="bg-warning/10 border border-warning/30 rounded-lg p-4 md:p-5 lg:p-6 mb-4 md:mb-5 lg:mb-6">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 mt-0.5">
          <Icon name="AlertTriangle" size={20} color="var(--color-warning)" strokeWidth={2} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm md:text-base font-medium text-warning mb-2">
            Please write anonymously
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground leading-relaxed">
            Avoid names, workplaces, locations, or other identifying details. Posts that reveal identities may be taken down.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnonymityWarning;